import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import gameData from '../gameData';
import UIAssetKeys from '../UIAssetKeys';

const PAINT_BLOCK_CANVAS_KEY = "paintblockcanvas";
const HANDLE_CANVAS_KEY = "handlecanvas";
const HANDLE_OUTLINE_CANVAS_KEY = "handleoutlinecanvas";
const POCKET_CANVAS_KEY = "pocketcanvas";
const OUTLINES_CANVAS_KEY = "outlinescanvas";
const ACCESSORIES_CANVAS_KEY = "accessoriescanvas";
const STENCIL_CANVAS_KEY = "stencilcanvas";
const PATTERN_CANVAS_KEY = "patterncanvas";
const FULL_BACKPACK_CANVAS_KEY = "fullbackpackcanvas";
let canvasIndex = 0;

export default class BackpackLayers extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     */
    constructor(scene, x, y, whichOne)
    {
        super(scene, x, y);

        this.currentBackpack = whichOne || 0;
        this.partsData = gameData.backpackParts[this.currentBackpack];

        this.canvasIndex = canvasIndex;

        this.slabSize = 640;
        this.paintBlock = this.scene.textures.createCanvas(PAINT_BLOCK_CANVAS_KEY + this.canvasIndex, this.slabSize, this.slabSize);
        this.handleCanvas = this.scene.textures.createCanvas(HANDLE_CANVAS_KEY + this.canvasIndex, 100, 100);
        this.handleOutlineCanvas = this.scene.textures.createCanvas(HANDLE_OUTLINE_CANVAS_KEY + this.canvasIndex, 100, 100);
        this.pocketCanvas = this.scene.textures.createCanvas(POCKET_CANVAS_KEY + this.canvasIndex, 100, 100);
        this.outlinesCanvas = this.scene.textures.createCanvas(OUTLINES_CANVAS_KEY + this.canvasIndex, 100, 100);
        this.accessoriesCanvas = this.scene.textures.createCanvas(ACCESSORIES_CANVAS_KEY + this.canvasIndex, 100, 100);
        this.stencilCanvas = this.scene.textures.createCanvas(STENCIL_CANVAS_KEY + this.canvasIndex, 100, 100);
        this.patternCanvas = this.scene.textures.createCanvas(PATTERN_CANVAS_KEY + this.canvasIndex, 100, 100);

        const fullBackpackFrame = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, "backpack/" + this.partsData.stylePrefix + this.partsData.mainFill.textureName);
        this.fullBackpackMaskGraphic = this.scene.add.image(0, 0, ABCyaPhaser.Images.DEFAULT_ATLAS, fullBackpackFrame.name).setOrigin(0).setVisible(false);
        this.fullBackpackMask = this.fullBackpackMaskGraphic.createBitmapMask();
        this.fullBackPackCanvas = this.scene.textures.createCanvas(FULL_BACKPACK_CANVAS_KEY + this.canvasIndex, fullBackpackFrame.width, fullBackpackFrame.height);
        this.fullBackPackCanvas.context.drawImage(fullBackpackFrame.source.image, fullBackpackFrame.data.drawImage.x, fullBackpackFrame.data.drawImage.y, fullBackpackFrame.data.drawImage.width, fullBackpackFrame.data.drawImage.height, 0, 0, fullBackpackFrame.width, fullBackpackFrame.height);
        this.fullBackPackCanvas.refresh();
        this.fullBackpackCanvasImage = this.scene.add.image(0, 0, FULL_BACKPACK_CANVAS_KEY + this.canvasIndex).setOrigin(0);
        this.add(this.fullBackpackCanvasImage);

        this.scene.events.on(Phaser.Scenes.Events.POST_UPDATE, this.fixMaskPosition, this);
        this.once(Phaser.GameObjects.Events.DESTROY, () =>
        {
            this.scene.textures.remove(this.paintBlock);
            this.scene.textures.remove(this.handleCanvas);
            this.scene.textures.remove(this.handleOutlineCanvas);
            this.scene.textures.remove(this.pocketCanvas);
            this.scene.textures.remove(this.outlinesCanvas);
            this.scene.textures.remove(this.accessoriesCanvas);
            this.scene.textures.remove(this.stencilCanvas);
            this.scene.textures.remove(this.patternCanvas);
            this.scene.textures.remove(this.fullBackPackCanvas);
            this.scene.events.off(Phaser.Scenes.Events.POST_UPDATE, this.fixMaskPosition, this);
        });

        canvasIndex++;

        this.paintBlockContext = this.paintBlock.getContext('2d');

        this.patternTile = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._game_assets_PATTERN_1, this).setOrigin(0).setVisible(false);

        this.handleSprite = ABCyaPhaser.Images.addImage(186, 0, "backpack/backpackstyle2/handle", this).setOrigin(0).setVisible(false);
        this.handleCanvasImage = this.scene.add.image(0, 0, HANDLE_CANVAS_KEY + this.canvasIndex).setOrigin(0).setVisible(false);
        this.add(this.handleCanvasImage);
        this.handleContainer = this.scene.add.container().setVisible(false);

        this.handleOutlineCanvasImage = this.scene.add.image(0, 0, HANDLE_OUTLINE_CANVAS_KEY + this.canvasIndex).setOrigin(0).setVisible(false);
        this.add(this.handleOutlineCanvasImage);
        this.handleOutlinesContainer = this.scene.add.container().setVisible(false);

        this.pocketCanvasImage = this.scene.add.image(0, 0, POCKET_CANVAS_KEY + this.canvasIndex).setOrigin(0);
        this.add(this.pocketCanvasImage);
        this.pocketContainer = this.scene.add.container().setVisible(false);

        this.outlinesCanvasImage = this.scene.add.image(0, 0, OUTLINES_CANVAS_KEY + this.canvasIndex).setOrigin(0);
        this.add(this.outlinesCanvasImage);
        this.outlinesContainer = this.scene.add.container().setVisible(false);

        this.accessoriesCanvasImage = this.scene.add.image(0, 0, ACCESSORIES_CANVAS_KEY + this.canvasIndex).setOrigin(0);
        this.add(this.accessoriesCanvasImage);
        this.accessoriesContainer = this.scene.add.container().setVisible(false);

        this.makeParts();
        var ci = { outline: '#000000', light: '#d3d3d3', dark: '#bcbaba', gradient: ['#3a3738', '#817e7f'], handle: ['#000000', '#d3d3d3'] };
        this.fillColor(ci, 'fill');
    }

    makeParts()
    {
        let partList = null;
        let i = 0;
        let len = 0;

        this.handleContainer.removeAll(true);
        this.handleOutlinesContainer.removeAll(true);
        this.pocketContainer.removeAll(true);
        this.outlinesContainer.removeAll(true);
        this.accessoriesContainer.removeAll(true);

        let handleList = this.partsData.handles;

        this.handleSprite.setVisible(false);
        this.handleCanvasImage.setVisible(false);
        this.handleOutlineCanvasImage.setVisible(false);

        if (handleList.singleTexture)
        {
            this.handleSprite.setVisible(true);
        }
        else if (handleList.fills)
        {
            partList = handleList.fills;
            len = partList.length;
            for (i = 0; i < len; i++)
            {
                let sn = "backpack/" + this.partsData.stylePrefix + partList[i].textureName;
                ABCyaPhaser.Images.addImage(partList[i].pos.x, partList[i].pos.y, sn, this.handleContainer).setOrigin(0);
            }
            let handleContainerBounds = this.handleContainer.getBounds();
            this.handleCanvas.setSize(handleContainerBounds.right, handleContainerBounds.bottom);
            this.handleContainer.iterate(go =>
            {
                this.handleCanvas.context.drawImage(go.frame.source.image, go.frame.data.drawImage.x, go.frame.data.drawImage.y, go.frame.data.drawImage.width, go.frame.data.drawImage.height, go.x, go.y, go.width, go.height);
            });
            this.handleCanvas.refresh();
            this.handleCanvasImage.setVisible(true);

            partList = handleList.outlines;
            len = partList.length;
            for (i = 0; i < len; i++)
            {
                let sn = "backpack/" + this.partsData.stylePrefix + partList[i].textureName;
                ABCyaPhaser.Images.addImage(partList[i].pos.x, partList[i].pos.y, sn, this.handleOutlinesContainer).setOrigin(0);
            }
            let handleOutlineContainerBounds = this.handleOutlinesContainer.getBounds();
            this.handleOutlineCanvas.setSize(handleOutlineContainerBounds.right, handleOutlineContainerBounds.bottom);
            this.handleOutlinesContainer.iterate(go =>
            {
                this.handleOutlineCanvas.context.drawImage(go.frame.source.image, go.frame.data.drawImage.x, go.frame.data.drawImage.y, go.frame.data.drawImage.width, go.frame.data.drawImage.height, go.x, go.y, go.width, go.height);
            });
            this.handleOutlineCanvas.refresh();
            this.handleOutlineCanvasImage.setVisible(true);
        }

        partList = this.partsData.pocketFills;
        len = partList.length;
        for (i = 0; i < len; i++)
        {
            let sn = "backpack/" + this.partsData.stylePrefix + partList[i].textureName;
            ABCyaPhaser.Images.addImage(partList[i].pos.x, partList[i].pos.y, sn, this.pocketContainer).setOrigin(0);
        }
        let pocketContainerBounds = this.pocketContainer.getBounds();
        this.pocketCanvas.setSize(pocketContainerBounds.right, pocketContainerBounds.bottom);
        this.pocketContainer.iterate(go =>
        {
            this.pocketCanvas.context.drawImage(go.frame.source.image, go.frame.data.drawImage.x, go.frame.data.drawImage.y, go.frame.data.drawImage.width, go.frame.data.drawImage.height, go.x, go.y, go.width, go.height);
        });
        this.pocketCanvas.refresh();

        partList = this.partsData.outlines;
        len = partList.length;
        for (i = 0; i < len; i++)
        {
            let sn = "backpack/" + this.partsData.stylePrefix + partList[i].textureName;
            ABCyaPhaser.Images.addImage(partList[i].pos.x, partList[i].pos.y, sn, this.outlinesContainer).setOrigin(0);
        }
        let outlinesContainerBounds = this.outlinesContainer.getBounds();
        this.outlinesCanvas.setSize(outlinesContainerBounds.right, outlinesContainerBounds.bottom);
        this.outlinesContainer.iterate(go =>
        {
            this.outlinesCanvas.context.drawImage(go.frame.source.image, go.frame.data.drawImage.x, go.frame.data.drawImage.y, go.frame.data.drawImage.width, go.frame.data.drawImage.height, go.x, go.y, go.width, go.height);
        });
        this.outlinesCanvas.refresh();

        partList = this.partsData.accessories;
        len = partList.length;
        for (i = 0; i < len; i++)
        {
            let sn = "backpack/" + this.partsData.stylePrefix + partList[i].textureName;
            ABCyaPhaser.Images.addImage(partList[i].pos.x, partList[i].pos.y, sn, this.accessoriesContainer).setOrigin(0);
        }
        let accessoriesBounds = this.accessoriesContainer.getBounds();
        this.accessoriesCanvas.setSize(accessoriesBounds.right, accessoriesBounds.bottom);
        this.accessoriesContainer.iterate(go =>
        {
            this.accessoriesCanvas.context.drawImage(go.frame.source.image, go.frame.data.drawImage.x, go.frame.data.drawImage.y, go.frame.data.drawImage.width, go.frame.data.drawImage.height, go.x, go.y, go.width, go.height);
        });
        this.accessoriesCanvas.refresh();
    }

    fillColor(colorInfo, type)
    {
        var isStencil = false;
        if (type == 'fill')
        {
            this.setSlabColor(colorInfo.dark);
        }
        else if (type == 'gradient')
        {
            this.setSlabGradient(colorInfo.gradient[0], colorInfo.gradient[1]);
        }
        else
        {
            isStencil = true;
        }

        if (isStencil)
        {
            this.setSlabStencil(type, colorInfo.light);
            this.setSlabColor(colorInfo.dark);
            this.copyFromSlab(this.fullBackPackCanvas);

            this.fullBackPackCanvas.context.globalCompositeOperation = "source-atop";
            let dif = (this.stencilCanvas.width - this.fullBackPackCanvas.width) / 2;
            this.fullBackPackCanvas.context.drawImage(this.stencilCanvas.canvas, 0, 0, this.stencilCanvas.width, this.stencilCanvas.height, -dif, 0, this.stencilCanvas.width, this.stencilCanvas.height);
            this.fullBackPackCanvas.context.globalCompositeOperation = "source-over";
            this.fullBackPackCanvas.refresh();
        }
        else
        {
            this.copyFromSlab(this.fullBackPackCanvas);
        }


        if (this.partsData.handles.fills)
        {
            this.setSlabColor(colorInfo.handle[1]);
            this.copyFromSlab(this.handleCanvas);
        }

        if (this.partsData.handles.outlines)
        {
            this.setSlabColor(colorInfo.handle[0]);
            this.copyFromSlab(this.handleOutlineCanvas);
        }

        this.setSlabColor(colorInfo.light);
        this.copyFromSlab(this.pocketCanvas);

        this.setSlabColor(colorInfo.outline);
        this.copyFromSlab(this.outlinesCanvas);
    }

    setSlabColor(color)
    {
        if (color == void (0)) color = "#000000";
        let ctx = this.paintBlockContext;
        ctx.globalCompositeOperation = "source-over";
        ctx.fillStyle = color;
        ctx.fillRect(0, 0, this.slabSize, this.slabSize);
    }

    setSlabGradient(color1, color2)
    {
        let ctx = this.paintBlockContext;
        ctx.globalCompositeOperation = "source-over";
        let gradient = ctx.createLinearGradient(0, 0, 0, this.slabSize);
        gradient.addColorStop(0, color1);
        gradient.addColorStop(1, color2);
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, this.slabSize, this.slabSize);
    }

    setSlabStencil(type, color)
    {
        this.stencilCanvas.context.clearRect(0, 0, this.stencilCanvas.width, this.stencilCanvas.height);
        const frame = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, "game-assets/" + type);
        this.stencilCanvas.setSize(frame.width, frame.height);
        this.stencilCanvas.context.drawImage(frame.source.image, frame.data.drawImage.x, frame.data.drawImage.y, frame.data.drawImage.width, frame.data.drawImage.height, 0, 0, this.stencilCanvas.width, this.stencilCanvas.height);

        this.setSlabColor(color);

        this.stencilCanvas.context.globalCompositeOperation = "source-in";
        this.stencilCanvas.context.drawImage(this.paintBlock.canvas, 0, 0);
        this.stencilCanvas.context.globalCompositeOperation = "source-over";
    }

    copyFromSlab(destObj)
    {
        let ctx = destObj.context;
        ctx.globalCompositeOperation = "source-in";
        ctx.drawImage(this.paintBlock.canvas, 0, 0);
        ctx.globalCompositeOperation = "source-over";
        destObj.refresh();
    }

    drawPattern(index, patternName)
    {
        this.patternCanvas.context.clearRect(0, 0, this.patternCanvas.width, this.patternCanvas.height);
        const frame = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, patternName);
        this.patternCanvas.setSize(frame.width, frame.height);
        this.patternCanvas.context.drawImage(frame.source.image, frame.data.drawImage.x, frame.data.drawImage.y, frame.data.drawImage.width, frame.data.drawImage.height, 0, 0, this.patternCanvas.width, this.patternCanvas.height);

        if (gameData.menu[2].data[index].tileType == "square")
        {
            this.fillSlabWithTile();
            this.copyFromSlab(this.fullBackPackCanvas);
        }
        else
        {
            let hW = gameData.menu[2].data[index].xoff;
            let hH = gameData.menu[2].data[index].yOff;
            this.fillSlabWithHexTile(hW, hH);
            this.copyFromSlab(this.fullBackPackCanvas);
        }
    }

    fillSlabWithTile()
    {
        this.setSlabColor();
        let tileWidth = this.patternCanvas.width;
        let tileHeight = this.patternCanvas.height;

        let rows = Math.ceil(this.slabSize / tileHeight);
        let cols = Math.ceil(this.slabSize / tileWidth);
        let ctx = this.paintBlockContext;
        ctx.globalCompositeOperation = "source-over";

        for (let row = 0; row < rows; row++)
        {
            for (let col = 0; col < cols; col++)
            {
                ctx.drawImage(this.patternCanvas.canvas, col * tileWidth, row * tileHeight);
            }
        }
    }

    fillSlabWithHexTile(hW, hH)
    {
        this.setSlabColor();
        let tileWidth = this.patternCanvas.width;
        let tileHeight = this.patternCanvas.height;

        let rows = Math.ceil(this.slabSize / tileHeight) + 1;

        let x = -hW;
        let y = 0;
        let ctx = this.paintBlockContext;
        ctx.globalCompositeOperation = "source-over";

        let finished = false;
        let alt = false;
        while (!finished)
        {
            for (let row = 0; row < rows; row++)
            {
                ctx.drawImage(this.patternCanvas.canvas, x, row * tileHeight - y);
            }
            if (alt == true)
            {
                ctx.drawImage(this.patternCanvas.canvas, x, -tileHeight - y);
            }

            alt = !alt;
            y = (alt) ? -hH : 0;
            x += tileWidth - hW;

            if (x >= this.slabSize) finished = true;
        }
    }

    fixMaskPosition()
    {
        const screenPos = ABCyaPhaser.GameObjects.getScreenPosition(this);
        this.fullBackpackMaskGraphic.setPosition(screenPos.x, screenPos.y);
    }

    setFreshBag(index)
    {
        this.cleanUpParts();

        this.currentBackpack = index;
        this.partsData = gameData.backpackParts[this.currentBackpack];

        const fullBackpackFrame = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, "backpack/" + this.partsData.stylePrefix + this.partsData.mainFill.textureName);
        this.fullBackpackMaskGraphic.setFrame(fullBackpackFrame.name).setOrigin(0).setVisible(false);
        this.fullBackPackCanvas.setSize(fullBackpackFrame.width, fullBackpackFrame.height);
        this.fullBackPackCanvas.context.clearRect(0, 0, this.fullBackPackCanvas.width, this.fullBackPackCanvas.height);
        this.fullBackPackCanvas.context.drawImage(fullBackpackFrame.source.image, fullBackpackFrame.data.drawImage.x, fullBackpackFrame.data.drawImage.y, fullBackpackFrame.data.drawImage.width, fullBackpackFrame.data.drawImage.height, 0, 0, fullBackpackFrame.width, fullBackpackFrame.height);
        this.fullBackPackCanvas.refresh();
        this.fullBackpackCanvasImage.setSizeToFrame(fullBackpackFrame);

        this.makeParts();
        var ci = { outline: '#000000', light: '#d3d3d3', dark: '#bcbaba', gradient: ['#3a3738', '#817e7f'], handle: ['#000000', '#d3d3d3'] };
        this.fillColor(ci, 'fill');
    }

    cleanUpParts()
    {
        this.handleContainer.removeAll(true);
        this.handleOutlinesContainer.removeAll(true);
        this.pocketContainer.removeAll(true);
        this.outlinesContainer.removeAll(true);
        this.accessoriesContainer.removeAll(true);
    }
}